import React from 'react';
import './VitaminProgram.css';

interface VitaminItem {
    slug: string;
    name: string;
    description: string;
    icon: string;
}

interface VitaminProgramProps {
    month: string;
    vitamins: VitaminItem[];
    locked?: boolean;
}

export const VitaminProgram: React.FC<VitaminProgramProps> = ({ month, vitamins, locked }) => {
    return (
        <main className="layout__content">
            {/* Блюрим только контент с витаминами */}
            <section className={`section layout__section program vitamins ${locked ? 'blurred' : ''}`}>
                <div className="container">
                    <header className="section__header program__header program-header">
                        <div className="program-header__top program-header-top program-header-top_no-margin">
                            <div className="program-header-top__inner">
                                <div className="program-header-top__left">
                                    <div className="program__title-wrapper">
                                        <h1 className="title section__title">Витамины</h1>
                                        <div className="program__time-badge">на {month} месяц</div>
                                        <div className="program-header-top__image-wrapper">
                                            <img
                                                className="program-header-top__image"
                                                src="/img/program-vitamins-image1.png"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <span className="program__label">Наши рекомендации для вас</span>
                                </div>
                                <div className="program-header-top__right"></div>
                            </div>
                        </div>
                        <div className="program-header__bottom program-header-bottom">
                            <div className="program-header-bottom__inner">
                                <div className="program-header-bottom__left">
                                    <p className="program__note">
                                        Ниже ваш план по витаминам на месяц. Рекомендуется пропить профилактическую дозу.
                                    </p>
                                </div>
                                <div className="program-header-bottom__right">
                                    <p className="program__description">
                                        Только то, чего по результатам теста вам может не хватать. Мы предлагаем небольшие дозировки. Наш партнёр Lab4U — скидка 50%.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </header>

                    <div className="section__content">
                        <div className="vitamins__list vitamins-list">
                            {vitamins.map((item, index) => (
                                <div key={item.slug} className="vitamins-list__item vitamins-list-item">
                                    <div className="vitamins-list-item__image-wrapper">
                                        <img className="vitamins-list-item__image" src={item.icon} alt={item.name} />
                                    </div>
                                    <div className="vitamins-list-item__info-wrapper">
                                        <h4 className="title vitamins-list-item__title">
                                            {index + 1}/ {item.name}
                                        </h4>
                                        <p className="vitamins-list-item__description">{item.description}</p>
                                        <div className="vitamins-list-item__action">
                                            <a className="button button_link" href={`/groups/${item.slug}`}>
                                                Пополнить
                                                <svg className="svg-icon button__icon">
                                                    <use href="/img/sprite-icons.svg#arrow-right"></use>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="reviews__return reviews__return_mobile">
                            <a className="button button_link" href="#">
                                Наверх
                                <svg className="svg-icon button__icon">
                                    <use href="/img/sprite-icons.svg#arrow-up"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Модальное окно блокировки */}
            {locked && (
                <div className="modalV">
                    <div className="modal__contentV">
                        <h2>
                            <strong style={{display: 'flex', fontSize: '20px'}}><svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 22.5C5.45 22.5 4.97933 22.3043 4.588 21.913C4.19667 21.5217 4.00067 21.0507 4 20.5V10.5C4 9.95 4.196 9.47933 4.588 9.088C4.98 8.69667 5.45067 8.50067 6 8.5H7V6.5C7 5.11667 7.48767 3.93767 8.463 2.963C9.43833 1.98833 10.6173 1.50067 12 1.5C13.3827 1.49933 14.562 1.987 15.538 2.963C16.514 3.939 17.0013 5.118 17 6.5V8.5H18C18.55 8.5 19.021 8.696 19.413 9.088C19.805 9.48 20.0007 9.95067 20 10.5V20.5C20 21.05 19.8043 21.521 19.413 21.913C19.0217 22.305 18.5507 22.5007 18 22.5H6ZM12 17.5C12.55 17.5 13.021 17.3043 13.413 16.913C13.805 16.5217 14.0007 16.0507 14 15.5C13.9993 14.9493 13.8037 14.4787 13.413 14.088C13.0223 13.6973 12.5513 13.5013 12 13.5C11.4487 13.4987 10.978 13.6947 10.588 14.088C10.198 14.4813 10.002 14.952 10 15.5C9.998 16.048 10.194 16.519 10.588 16.913C10.982 17.307 11.4527 17.5027 12 17.5ZM9 8.5H15V6.5C15 5.66667 14.7083 4.95833 14.125 4.375C13.5417 3.79167 12.8333 3.5 12 3.5C11.1667 3.5 10.4583 3.79167 9.875 4.375C9.29167 4.95833 9 5.66667 9 6.5V8.5Z" fill="black"/>
                            </svg>
                                Доступ к подбору витаминов временно ограничен</strong>
                        </h2>
                        <p>
                            Чтобы мы могли рекомендовать вам подходящие витамины, сначала нужно сдать рекомендуемые
                            анализы — список доступен на странице <strong>«Результаты анализов»</strong>.
                        </p>
                        <p>
                            Как только вы пройдёте анализы, данные автоматически поступят из{' '}
                            <a href="https://lab4u.ru" target="_blank" rel="noreferrer">LAB4U</a>, и мы сформируем
                            персональные рекомендации по витаминам специально для вас.
                        </p>
                        <button
                            className="modal__submitV"
                            onClick={() => (window.location.href = '/results')}
                        >
                            Перейти к анализам
                        </button>
                    </div>
                </div>
            )}
        </main>
    );
};
